var _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoAddMember(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  var color = props.fillColor || "#0F3951";
  var outlineColor = props.filled ? 'none' : color;
  var filledColor = props.filled ? color : 'none';
  delete props.filled;
  delete props.fillColor;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.09,34.22a10.61,10.61,0,1,1,10.6-10.6A10.61,10.61,0,0,1,18.09,34.22Zm0-17a6.37,6.37,0,1,0,6.36,6.37A6.38,6.38,0,0,0,18.09,17.25Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.91,41.11C6.58,38.29,12.45,36,18.09,36s11.45,2.3,14.14,5.1c1,1-2.9,3-3.14,2.82-1.4-1.35-5.61-3.67-11-3.67s-9.64,2.33-11,3.68C7,44,3.44,41.6,3.91,41.11Z",
    fill: outlineColor
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.89,8.56H39.33V5a2,2,0,1,0-4,0V8.56H31.77a2,2,0,0,0,0,4h3.56v3.56a2,2,0,1,0,4,0V12.56h3.56a2,2,0,0,0,0-4Z",
    fill: outlineColor
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAddMember);
export default __webpack_public_path__ + "static/media/ico-add-member.631ffefc84a533efea730f05869b0f56.svg";
export { ForwardRef as ReactComponent };
ForwardRef.hasFilled = false;